import type {
  CSSProperties,
} from 'react';

import type {
  StyledProps,
} from 'styled-components';

import type {
  BaseCellProps,
} from './types';

export const makeDefaultCellStyle = ({
  isMinWidth,
  isNowrap,
  hasWordBreak,
  width,
  textAlign = 'left',
  verticalAlign = 'top',

  theme: {
    colors,
  },
}: StyledProps<BaseCellProps>): CSSProperties => {
  const res: CSSProperties = {
    boxSizing: 'border-box',
    backgroundColor: colors.NEUTRAL_WHITE,
    verticalAlign,
    textAlign,
  };

  if (isMinWidth) {
    res.width = 1;
  }

  if (isNowrap) {
    res.whiteSpace = 'nowrap';
  }

  if (hasWordBreak) {
    res.wordBreak = 'break-all';
    res.wordBreak = 'break-word';
    res.wordWrap = 'break-word';
  }

  if (width) {
    res.width = width;
  }

  return res;
};
